import styles from './PrintLink.module.css';

/**
 * Proposal B — quiet "Print" text link with a clean printer icon.
 * Neutral grey; on hover it tints to `accent` (the act colour) and underlines the label.
 * Hidden in printed output via @media print. Shared by all in-app reader pages.
 */
export function PrintLink({ accent }: { accent?: string }) {
  return (
    <button
      type="button"
      className={styles.printLink}
      onClick={() => window.print()}
      title="Print / Save as PDF"
      aria-label="Print"
      style={accent ? ({ '--print-accent': accent } as React.CSSProperties) : undefined}
    >
      <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round" style={{ flexShrink: 0 }}>
        <polyline points="6 9 6 2 18 2 18 9" />
        <path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2" />
        <rect x="6" y="14" width="12" height="8" />
      </svg>
      <span className={styles.t}>Print</span>
    </button>
  );
}
